import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AdditionalDataItemType } from '../../Constants/Enums/Domain/AdditionalDataItemType';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class AdditionalDataItemClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number, type: AdditionalDataItemType): Promise<Array<string>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AdditionalDataItem/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, type: type }

    return AjaxWrapper.get<Array<string>, any>(url, data);
  }
  public put(customerId: number, type: AdditionalDataItemType, additionalDataItem: string): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AdditionalDataItem/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, type: type, additionalDataItem: additionalDataItem }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
  public delete(customerId: number, type: AdditionalDataItemType): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/AdditionalDataItem/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, type: type }

    return AjaxWrapper.delete<ValidationStatus, any>(url, data);
  }
}

